import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  IconButton,
  DialogTitle,
  FormHelperText,
  CardMedia,
} from "@mui/material";
import { Close as CloseIcon, Info as InfoIcon } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useWeb3Context } from "../../context/UseWeb3Context";
import { getUser, printTee } from "../../api/users";
import { TitleText } from "../../components/common/TitleText";
import { useSnackbar } from "notistack";
import DialogComponent from "../../components/common/DialogComponent";
import SizeChart from "../../assets/images/size_chart.jpeg";

// import { UseUserDocContext } from "../../context/UserDocProvider";
import { firestore } from "../../firebase";
import { doc } from "firebase/firestore";

const sizes = [
  "XS-White",
  "S-White",
  "M-White",
  "L-White",
  "XL-White",
  "XS-Black",
  "S-Black",
  "M-Black",
  "L-Black",
  "XL-Black",
];
const PrintTeeModal = ({
  openModal,
  closeModal,
  mintDataToken,
  mintHashCode,
}) => {
  const { account } = useWeb3Context();
  const [loggedInUser, setLoggedInUser] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [showSizeChart, setShowSizeChart] = useState(false);
  // const { docData } = UseUserDocContext();
  const [docData, setDocData] = useState();
  useEffect(() => {
    const getDocData = async () => {
      const docToProcess = await doc(firestore, "users", account);
      // console.log("docToProcess :", docToProcess);

      setDocData(docToProcess);
    };
    if (!(account === undefined)) {
      getDocData();
    }
  }, [account]);

  useEffect(() => {
    if (account) {
      getUser(account).then((res) => {
        setLoggedInUser(res);
      });
    }
  }, [account]);

  const [size, setSize] = useState("");
  const [message, setMessage] = useState("");
  const billingAddress = loggedInUser?.address
    ? loggedInUser?.address?.street +
      ", " +
      loggedInUser?.address?.city +
      ", " +
      loggedInUser?.address?.state +
      ", " +
      loggedInUser?.address?.country +
      ", " +
      loggedInUser?.address?.zip
    : "";
  const submitPrintTee = () => {
    setMessage("");

    printTee(
      {
        address: billingAddress,
        account,
        size,
        fullName: loggedInUser?.fullname,
        mintDataToken,
        mintHashCode,
      },
      docData
    )
      .then((response) => {
        // console.log({ response });

        enqueueSnackbar("Submitted successfully...!!!", {
          variant: "success",
          autoHideDuration: 1500,
        });
        closeModal();
      })
      .catch((error) => {
        console.log({ error });
        enqueueSnackbar("Something went wrong", {
          variant: "success",
          autoHideDuration: 1500,
        });
      });
  };
  return (
    <DialogComponent open={openModal} onClose={closeModal}>
      <DialogTitle>
        <IconButton
          aria-label="close"
          onClick={showSizeChart ? () => setShowSizeChart(false) : closeModal}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {showSizeChart ? (
        <>
          {" "}
          <CardMedia
            component="img"
            image={SizeChart}
            alt="image"
            sx={{
              objectFit: "fill",
              //   height: { md: "512px },
              //   width: { md: "346px" },
            }}
          ></CardMedia>
        </>
      ) : (
        <DialogContent sx={{ m: 1 }}>
          <Box display="flex" alignItems="center">
            <Box>
              <FormControl sx={{ my: 2, minWidth: 250 }} size="small">
                <InputLabel id="demo-select-small">Size</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={size}
                  label="Age"
                  sx={{ width: "40%" }}
                  onChange={(e) => {
                    if (e.target.value === "") {
                      setMessage("Please select size");
                      setSize("");
                      return;
                    }
                    setMessage("");
                    setSize(e.target.value);
                  }}
                >
                  <MenuItem value="">Select size</MenuItem>
                  {sizes.map((size) => {
                    return (
                      <MenuItem key={size} value={size}>
                        {size}
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText error sx={{ ml: 0, fontSize: "0.875rem" }}>
                  {message}
                </FormHelperText>
              </FormControl>
            </Box>
            <Box
              sx={{
                position: "absolute",
                right: "46%",
                top: "25%",
                "&:hover": { cursor: "pointer" },
              }}
              onClick={() => setShowSizeChart(true)}
            >
              <InfoIcon />
            </Box>
          </Box>
          <Box>
            <TitleText variant="h6" fontWeight="bold">
              Billing Address
            </TitleText>

            <TitleText
              sx={{
                display: "block",
                mt: 1,
                color: !billingAddress && "red",
                overflowWrap: "break-word",
              }}
              variant="h6"
            >
              {billingAddress
                ? billingAddress
                : "Please add address from your profile"}
            </TitleText>

            <DialogActions>
              <Button variant="contained" onClick={closeModal}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={submitPrintTee}
                disabled={!billingAddress || size === ""}
              >
                Submit
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      )}
    </DialogComponent>
  );
};

export default PrintTeeModal;
